export default "__VITE_ASSET__be463ba8__"